import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { extensionOptionActions } from '../state/extension-option.actions';
import { extensionOptionSelectors } from '../state/extension-option.reducer';

@Directive({
    selector: '[ndtExtensionSelect]',
    standalone: false
})
export class ExtensionSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() extensionType: number | null;

   @Input() extensionTypesToExclude: number[];

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   protected destroyed$ = new Subject<void>();

   private initializeSub?: Subscription;

   constructor(
      protected elementRef: ElementRef,
      protected formField: MatFormField,
      protected trigger: LcsSingleSelectDirective<ExtensionOption>,
      protected statusService: NgrxEagerSelectService<AppState, ExtensionOption>,
      protected store: Store<AppState>
   ) {}

   ngAfterViewInit(): void {
      this.runInitialize();
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.accountId || changes.extensionType || changes.extensionTypesToExclude) {
         this.store.dispatch(
            extensionOptionActions.load({
               additionalFields: this.additionalFields,
               filterOverrides: this.buildFilters(),
               urlOverride: this.urlOverride,
            })
         );
      }
      this.runInitialize();
   }
   private runInitialize(): void {
      this.initializeSub?.unsubscribe();
      this.initializeSub = this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            extensionOptionActions,
            extensionOptionSelectors,
            () => this.additionalFields,
            () => this.urlOverride,
            () => this.statusService.buildPrimaryKeyFilterExpression('extensionId', this.trigger),
            this.buildFilters()
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   buildFilters(): string[] {
      let staticFilterOverride: string[] = [];
      staticFilterOverride.push(`IsArchived = false`);
      if (this.accountId) {
         staticFilterOverride.push(`AccountId = ${this.accountId}`);
      }
      if (this.extensionType) {
         staticFilterOverride.push(`Type = ${this.extensionType}`);
      }
      if (this.extensionTypesToExclude) {
         staticFilterOverride.push(`Type not in (${this.extensionTypesToExclude.join(',')})`);
      }
      return staticFilterOverride;
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
      this.initializeSub?.unsubscribe();
   }
}
